export default __webpack_public_path__ + "static/media/BannerCS-10May(1440x600).6b55ecbf.webp";